import * as React from 'react';
const { useEffect } = React;
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import api from '@seeneco-ui/api';
import { getPropInSafe } from '@seeneco-ui/core/utils';

import { useAuthContext } from '../../../auth/context';
import { tenantActionsPack } from '../../actions';
import { tenantSelectorsPack } from '../../selectors';
import XAppSession, { AppSessionProps as XAppSessionProps } from './app-session.view';
import { getAuthParams } from '../../../auth/utils/index';


type AppSessionProps = {
	isFetching?: boolean;
	isSessionContextLoaded?: boolean;
	isTenantAccountLoaded?: boolean;
	sessionContext?: ClientSessionContext;
	tenantAccount?: TenantAccount;
	fetchSessionContext?: (ticketUID: string) => void;
	fetchTenantAccount?: (tenantID: number) => void;
} & Omit<XAppSessionProps,
	'isFetching'
	| 'sessionContext'
	| 'tenantAccount'
	| 'onLogout'>;

const AppSession: React.FC<AppSessionProps> = (props) => {
	const {
		appearance,
		isFetching,
		isSessionContextLoaded,
		isTenantAccountLoaded,
		sessionContext,
		tenantAccount,
		fetchSessionContext,
		fetchTenantAccount,
		...rest
	} = props;
	const { ticketUID } = useAuthContext();
	const tenantID = getPropInSafe(sessionContext, o => o.SessionTenant.ID, -1);

	useEffect(() => {
		!isSessionContextLoaded && fetchSessionContext(ticketUID);
	}, [ticketUID, isSessionContextLoaded]);

	useEffect(() => {
		!isTenantAccountLoaded && tenantID > 0 && fetchTenantAccount(tenantID);
	}, [tenantID, isTenantAccountLoaded]);

	const { businessService } = getAuthParams();
	const handleLogout = () => api.platform.auth.logout({ businessService });

	return (
		<XAppSession
			{...rest}
			appearance={appearance}
			isFetching={isFetching}
			sessionContext={sessionContext}
			tenantAccount={tenantAccount}
			onLogout={handleLogout}
		/>
	);
}

const selectIsFetching = (state) => tenantSelectorsPack.selectAsyncSessionContext.selectIsFetching(state)
	|| tenantSelectorsPack.selectAsyncTenantAccount.selectIsFetching(state);

function mapStateToProps(state) {
	return {
		isFetching: selectIsFetching(state),
		isSessionContextLoaded: tenantSelectorsPack.selectAsyncSessionContext.selectIsLoaded(state),
		isTenantAccountLoaded: tenantSelectorsPack.selectAsyncTenantAccount.selectIsLoaded(state),
		sessionContext: tenantSelectorsPack.selectAsyncSessionContext.selectItem(state),
		tenantAccount: tenantSelectorsPack.selectAsyncTenantAccount.selectItem(state),
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		fetchSessionContext: tenantActionsPack.actions.fetchSessionContext,
		fetchTenantAccount: tenantActionsPack.actions.fetchTenantAccount,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AppSession);
